import { useRef, useState } from 'react';
import '../../style/Header.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { FaFacebook, FaPhone, FaInstagram, FaEnvelope, FaIdCard, FaUsers, FaRegLightbulb } from "react-icons/fa";
import logo from '../images/Logon.png';


function Header() {
  const [startDropdownOpen, setStartDropdownOpen] = useState(false);
  const [tunesienDropdownOpen, setTunesienDropdownOpen] = useState(false);
  const dropdownCloseTimeout = useRef(null);
  const tunesienDropdownTimeout = useRef(null);
  const isMobile = () => window.matchMedia("(max-width: 992px)").matches;

  const handleDropdownEnter = () => {
    if (isMobile()) return;
    if (dropdownCloseTimeout.current) {
      clearTimeout(dropdownCloseTimeout.current);
    }
    setStartDropdownOpen(true);
  };

  const handleDropdownLeave = () => {
    if (isMobile()) return;
    dropdownCloseTimeout.current = setTimeout(() => {
      setStartDropdownOpen(false);
    }, 120); // small delay to avoid flicker while moving cursor
  };

  const handleTunesienEnter = () => {
    if (isMobile()) return;
    if (tunesienDropdownTimeout.current) {
      clearTimeout(tunesienDropdownTimeout.current);
    }
    setTunesienDropdownOpen(true);
  };

  const handleTunesienLeave = () => {
    if (isMobile()) return;
    tunesienDropdownTimeout.current = setTimeout(() => {
      setTunesienDropdownOpen(false);
    }, 120);
  };

  const handleStartClick = (event) => {
    if (!isMobile()) return;
    event.preventDefault();
    setStartDropdownOpen((prev) => !prev);
    setTunesienDropdownOpen(false);
  };

  const handleTunesienClick = (event) => {
    if (!isMobile()) return;
    event.preventDefault();
    setTunesienDropdownOpen((prev) => !prev);
    setStartDropdownOpen(false);
  };
  

  return (
    <div className="medway-header">
      <Navbar className="medway-topbar">
        <div className="medway-topbar__inner">
          
          <div className="medway-topbar__left">
  
  {/* Phone clickable */}
  <a
    href="tel:+21651613741"
    className="medway-topbar__link"
  >
    <FaPhone /> <span className="medway-topbar__text medway-topbar__phone-text">+216 51 613 741</span>
  </a>

  {/* Email clickable */}
  <a
    href="mailto:recruitmentmedway@gmail.com"
    className="medway-topbar__link"
  >
    <FaEnvelope /> <span className="medway-topbar__text">recruitmentmedway@gmail.com</span>
  </a>

</div>

          {/* RIGHT SIDE: SOCIAL ICONS */}
          <div className="medway-topbar__right">
            <a href="https://www.facebook.com/MedWayRecruitment/" target="_blank" rel="noreferrer">
              <FaFacebook size={22} color="white" />
            </a>

            <a href="https://www.instagram.com/medway.recruitment/" target="_blank" rel="noreferrer">
              <FaInstagram size={22} color="white" />
            </a>
          </div>
        </div>

      </Navbar>

      {/* Zweite Navbar – direkt darunter */}
      <Navbar expand="lg" className="medway-mainnav">
        <Container
          fluid
          className="medway-mainnav__inner"
        >
          <Navbar.Brand href="/" style={{ display: "flex", alignItems: "center" }}>
            <img className="medway-logo" src={logo} alt="LogoMed" />
          </Navbar.Brand>

          {/* Always visible on mobile/tablet (outside collapse) */}
          <a href="/Kontakt" className="medway-mainnav__cta medway-mainnav__cta--mobile">
            Kontakt
          </a>

          <Navbar.Toggle />

          <Navbar.Collapse
            className="medway-mainnav__collapse justify-content-end"
          >
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <div
                className="medway-mainnav__links"
              >
                <div
                  style={{ position: "relative" }}
                  onMouseEnter={handleDropdownEnter}
                  onMouseLeave={handleDropdownLeave}
                >
                  <Nav.Link href="/" onClick={handleStartClick}>
                    Startseite
                  </Nav.Link>
                  <div
                    onMouseEnter={handleDropdownEnter}
                    onMouseLeave={handleDropdownLeave}
                    className="medway-dropdown"
                    style={{ display: startDropdownOpen ? "block" : "none" }}
                  >
                    <Nav.Link
                      href="/Ueber-uns"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      <FaIdCard size={20} color="#111D4B" /> Über uns
                    </Nav.Link>
                    <Nav.Link
                      href="/Team"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#111D4B", fontSize: 18, padding: "6px 4px" }}
                    >
                      <FaUsers size={20} color="#111D4B" /> Team
                    </Nav.Link>
                    <Nav.Link
                      href="/Vision-Mission"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      <FaRegLightbulb size={20} color="#111D4B" /> Vision-Mission
                    </Nav.Link>
                  </div>
                </div>
                <Nav.Link style={{ color: "black" }} href="/Dienstleistung">
                  Dienstleistung
                </Nav.Link>
                <div
                  style={{ position: "relative" }}
                  onMouseEnter={handleTunesienEnter}
                  onMouseLeave={handleTunesienLeave}
                >
                  <Nav.Link style={{ color: "black" }} href="/Tunesien" onClick={handleTunesienClick}>
                    Tunesien
                  </Nav.Link>
                  <div
                    onMouseEnter={handleTunesienEnter}
                    onMouseLeave={handleTunesienLeave}
                    className="medway-dropdown"
                    style={{ display: tunesienDropdownOpen ? "block" : "none" }}
                  >
                    <Nav.Link
                      href="/Tunesien#geographie"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      Geographie
                    </Nav.Link>
                    <Nav.Link
                      href="/Tunesien#geschichte"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#111D4B", fontSize: 18, padding: "6px 4px" }}
                    >
                      Geschichte
                    </Nav.Link>
                    <Nav.Link
                      href="/Tunesien#freizeit"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      Freizeitaktivitäten
                    </Nav.Link>
                    <Nav.Link
                      href="/Tunesien#kultur"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      Kultur
                    </Nav.Link>
                    <Nav.Link
                      href="/Tunesien#bildung"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      Bildung
                    </Nav.Link>
                    <Nav.Link
                      href="/Tunesien#familie"
                      style={{ display: "flex", alignItems: "center", gap: 10, color: "#222", fontSize: 18, padding: "6px 4px" }}
                    >
                      Familie und Religion
                    </Nav.Link>
                  </div>
                </div>
                <Nav.Link style={{ color: "black" }} href="/Dienstleistung#referenzen">
                  Referenzen
                </Nav.Link>
              </div>
            </div>
            {/* Desktop only (inside collapse) */}
            <div className="medway-mainnav__cta-wrap">
              <a href="/Kontakt" className="medway-mainnav__cta">
                Kontakt
              </a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
